import { Schema } from "effect";
import { OpenApiClass } from "../openapi-class.js";

/** A source and its existing advertisement ID form the external identity. */
export class JobAdIdentitySchema extends OpenApiClass<JobAdIdentitySchema>("JobAdIdentity")({
  source: Schema.Literals(["career", "jobtech"]),
  adId: Schema.NonEmptyString.pipe(Schema.check(Schema.isPattern(/\S/u))),
}) {}

/** Read stored status for a bounded batch; this request never starts collection. */
export class JobAdStatusesRequestSchema extends OpenApiClass<JobAdStatusesRequestSchema>(
  "JobAdStatusesRequest"
)({
  ads: Schema.Array(JobAdIdentitySchema).pipe(
    Schema.check(Schema.isMinLength(1)),
    Schema.check(Schema.isMaxLength(100))
  ),
}) {}

/** Explicit evidence explaining status; missing or stale evidence is never removal. */
export const JobAdStatusReasonSchema = Schema.Literals([
  "active_observation",
  "withdrawn",
  "career_closed",
  "expired",
  "missing",
  "stale_evidence",
  "inactive_without_removal",
  "unavailable_evidence",
  "future_evidence",
]);

/** Stored ad status with separate freshness for the supporting observation. */
export class JobAdStatusSchema extends OpenApiClass<JobAdStatusSchema>("JobAdStatus")({
  source: Schema.Literals(["career", "jobtech"]),
  adId: Schema.String,
  status: Schema.Literals(["open", "closed", "unknown"]),
  reason: JobAdStatusReasonSchema,
  deadline: Schema.OptionFromOptional(Schema.String),
  closedAt: Schema.OptionFromOptional(Schema.String),
  lastSeenAt: Schema.OptionFromOptional(Schema.String),
  freshness: Schema.Literals(["fresh", "stale", "unknown"]),
  freshnessAsOf: Schema.OptionFromOptional(Schema.String),
  freshUntil: Schema.OptionFromOptional(Schema.String),
}) {}

/** One result per requested identity, preserving the request order. */
export class JobAdStatusesResponseSchema extends OpenApiClass<JobAdStatusesResponseSchema>(
  "JobAdStatusesResponse"
)({
  results: Schema.Array(JobAdStatusSchema).pipe(
    Schema.check(Schema.isMinLength(1)),
    Schema.check(Schema.isMaxLength(100))
  ),
}) {}

export type JobAdStatusesRequest = Schema.Schema.Type<typeof JobAdStatusesRequestSchema>;
export type JobAdStatusesResponse = Schema.Schema.Type<typeof JobAdStatusesResponseSchema>;
